<script setup lang="ts">
  import { useAuthStore } from '@/stores/auth'
  import { useDashboardStore } from '@/stores/dashboard.ts'
  import SidebarItem from './sidebar-item.vue'
  import SidebarItemGroup from './sidebar-item-group.vue'

  const auth = useAuthStore()
  const dashboard = useDashboardStore()
</script>

<!-- eslint-disable vue/max-lines-per-block -->
<template>
  <div>
    <sidebar-item
      :to="{ name: 'home' }"
      icon="i-far-chart-line">
      Dashboard
    </sidebar-item>
    <!-- <sidebar-item
      :to="{ name: 'notification list' }"
      :count="0"
      class="lg:!hidden"
      count-title="Belum dibaca"
      icon="i-far-bell">
      Notifikasi
    </sidebar-item> -->

    <sidebar-item-group label="Transaksi">
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Penjualan')"
        :to="{ name: 'shop order list' }"
        icon="i-far-cash-register">
        Pesanan
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengonfirmasi Pembayaran Pelanggan')"
        :to="{ name: 'shop order payments list' }"
        :count="dashboard.shop_order_payment_count.pending"
        icon="i-far-money-check-dollar-pen">
        Cek Pembayaran
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Pelanggan')"
        :to="{ name: 'customer list' }"
        icon="i-far-user-group">
        Customer
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Ulasan')"
        :to="{ name: 'review list' }"
        :count="dashboard.reviews_count.need_moderation"
        icon="i-far-star-half-stroke">
        Ulasan
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Produk">
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Produk')"
        :to="{ name: 'product list' }"
        icon="i-far-boxes-stacked">
        Produk
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Kategori Produk')"
        :to="{ name: 'product category list' }"
        icon="i-far-tags">
        Kategori Produk
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Toko">
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Banner')"
        :to="{ name: 'banner list' }"
        icon="i-far-gallery-thumbnails">
        Banner
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Login Banner')"
        :to="{ name: 'login banner list' }"
        icon="i-far-images">
        Banner Login
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Metode Pembayaran')"
        :to="{ name: 'payment method list' }"
        icon="i-far-credit-card">
        Metode Pembayaran
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Voucher')"
        :to="{ name: 'voucher list' }"
        icon="i-far-ticket">
        Voucher
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Promo')"
        :to="{ name: 'promo list' }"
        icon="i-far-badge-percent">
        Promo
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Kurir')"
        :to="{ name: 'courier list' }"
        icon="i-far-truck">
        Kurir
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Lokasi Toko')"
        :to="{ name: 'store location list' }"
        icon="i-far-map">
        Lokasi Toko
      </sidebar-item>
    </sidebar-item-group>
    <!-- <sidebar-item-group
      v-if="auth.userCan('Mengakses Menu Pengaturan')"
      label="Pengaturan Toko">
      <sidebar-item
        :to="{ name: 'setting general' }"
        icon="i-far-square-sliders">
        Umum
      </sidebar-item>
      <sidebar-item
        :to="{ name: 'setting share product' }"
        icon="i-far-share">
        Share Produk
      </sidebar-item>
    </sidebar-item-group> -->
    <sidebar-item-group label="Pengaturan">
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Pengguna')"
        :to="{ name: 'user admin list' }"
        icon="i-far-user">
        Staff
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('Mengakses Menu Hak Akses')"
        :to="{ name: 'role list' }"
        icon="i-far-shield-check">
        Hak Akses
      </sidebar-item>
      <sidebar-item
        :to="{ name: 'change password' }"
        icon="i-far-user-lock">
        Ganti Password
      </sidebar-item>
    </sidebar-item-group>
  </div>
</template>

<style>
  @reference "@/assets/styles/main.css";

  :root {
    --sidebar-item-margin-top: calc(var(--spacing) * 1);
    --sidebar-item-height: calc(var(--spacing) * 10); /* 40px */
    --sidebar-item-dropdown-height: calc(var(--spacing) * 8); /* 36px */
  }
  .sidebar-item {
    margin-top: var(--sidebar-item-margin-top);
    height: var(--sidebar-item-height);

    @apply flex w-full items-center space-x-4 rounded px-2 pl-1 text-left;
    @apply bg-gray/20;

    &:hover,
    &.router-link-active {
      @apply bg-primary-400/20;
    }
  }

  .sidebar-item-icon {
    @apply shrink-0;
  }
  .sidebar-item-count {
    @apply bg-warning rounded px-2 py-0.5 text-xs text-white;
  }

  .sidebar-item-dropdown-content {
    @apply transition-all duration-200 overflow-hidden;
    @apply -mx-2 px-2; /* fixes focus ring from getting clipped */

    .sidebar-item {
      height: var(--sidebar-item-dropdown-height);
    }
    &.collapsed > * {
      @apply invisible;
    }
  }
</style>
